// Feature flags for work that is built but not yet approved to go live.
//
// SHOW_SALARY_ESTIMATOR: the salary simulator (年収シミュレータ) is complete but is
// awaiting HR sign-off on the figures. While false, the CTA card is hidden from
// /recruitment (desktop + mobile) and /recruitment/salary falls through to the 404
// page. Nothing is deleted — flip this to true to bring the whole feature back.
export const SHOW_SALARY_ESTIMATOR = false;
